import React, {useState} from 'react';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import {IconButton} from "@mui/material";
import { H2 } from "components/CustomTypography";
import { Box, Button } from "@mui/material";
import ButtonComponent from "../Button";

export default function Story(props) {

  const {
    avatar,
      linkTitle1,
      linkTitle2,
    name,
    area,
      item,
      itemIndex,
      favId,
    duration,
    closeButton,
    toggleMute,
      isMuted,
      setFav,
      isSetAvailable,
    onCloseButtonClick,
      onButton1Click,
      onButton2Click,
    children,
    ...rest
  } = props;

    const [isFav, setIsFav] = useState(false);

    const handleSetFav = () => {
        if (!isFav) {
            setIsFav(true);
            setFav(favId);
        }
    }

    const handleButton1Event = () => {
        if (item) {
            onCloseButtonClick();
            onButton1Click(item, itemIndex);
        }
    }

    const handleButton2Event = () => {
        if (item) {
            onCloseButtonClick();
            onButton2Click(item, itemIndex);
        }
    }

  return (
      <div className="swiper-slide" data-duration={duration} {...rest}>

          <a className="stories-slider-user">
              {avatar && <div className="stories-slider-user-avatar">{avatar}</div>}
              <div>
                  {name && <H2 className="stories-slider-user-name" ellipsis>{name}</H2>}
                  {area && <div className="stories-slider-user-area">{area}</div>}
              </div>
          </a>

          <div className="stories-slider-actions">
              {linkTitle2 &&  <span style={{ paddingLeft: "10px", paddingRight: "10px" }}><ButtonComponent className="stories-slider-user-link" sx={{ p: 2, minWidth: "auto", backgroundColor: "white" }}
                                              type="primary"
                                              onClick={handleButton2Event}
                                              variant="outlined"
                                              name={linkTitle2}
                                              size="small">
              </ButtonComponent></span>}
              {linkTitle1 &&  <span style={{ paddingLeft: "10px", paddingRight: "10px" }}><ButtonComponent className="stories-slider-user-link" sx={{ p: 2, minWidth: "auto", backgroundColor: "white" }}
                                              type="primary"
                                              onClick={handleButton1Event}
                                              variant="outlined"
                                              name={linkTitle1}
                                              size="small">
              </ButtonComponent></span>}

              {isSetAvailable && <IconButton color={ isFav ? "primary" : "error"} onClick={handleSetFav}>
                  {isFav ? <FavoriteIcon fontSize="large"/> : <FavoriteBorderIcon fontSize="large"/>}
              </IconButton>
              }

              <IconButton sx={{color: "grey.100"}} onClick={toggleMute}>
                  {isMuted ? <VolumeOffIcon fontSize="large"/> : <VolumeUpIcon fontSize="large"/>}
              </IconButton>

              {closeButton && (
                  <button
                      className="stories-slider-close-button"
                      onClick={onCloseButtonClick}
                  />
              )}
          </div>
          <div className="stories-slider-content">{children}</div>
      </div>
  );
}
